define((require) => {
    "use strict";

    const {pick, isEqual}        = require("underscore");
    const Marionette             = require("marionette");
    const NotificationBar        = require("editor/ui/notificationbar/NotificationBar");
    const Preconditions          = require("shared/util/Preconditions");
    const Scene7HostedRegionEnum = require("editor/ui/settings/integrations/Scene7HostedRegionEnum");
    const SequentialButton       = require("util/SequentialButton");
    const Scene7IntegrationModel = require("editor/ui/settings/integrations/Scene7IntegrationModel");
    const template               = require("editor/ui/settings/integrations/Scene7IntegrationView.tpl");
    const Tooltip                = require("ui/common/Tooltip");

    // require scene7 example screenshot so that webpack includes the image in the build
    require("integration/addons/scene7/scene7-images-example.png");

    const SCENE7_SAVE_MESSAGE = "The Adobe Integration has been saved.";

    return Marionette.Layout.extend({
        template,

        templateHelpers() {
            Preconditions.checkState(typeof this.options.isManager === "boolean"); // check it's not null

            return {
                Scene7HostedRegionEnum,
                isManager: this.options.isManager
            };
        },

        ui: {
            saveButton: ".save-adobe-scene7-credentials",
            saveButtonTooltipWrapper: ".save-button-tooltip-wrapper",
            usernameInput: "[name=scene7-username]",
            passwordInput: "[name=scene7-password]",
            companyNameInput: "[name=companyName]",
            regionInput: "[name=region]"
        },

        events: {
            "click @ui.saveButton": "_save",
            "keyup @ui.usernameInput": "_updateModel",
            "keyup @ui.passwordInput": "_updateModel",
            "keyup @ui.companyNameInput": "_updateModel",
            "change @ui.regionInput": "_updateModel",
            "click @ui.passwordInput": "_focusPasswordInput"
        },

        _sequentialSaveButtonAction: null,

        initialize() {
            this.model = this._getScene7IntegrationModel();
            this._savedModelData = this.model.toJSON();
        },

        onRender() {
            this._sequentialSaveButtonAction = SequentialButton.add(this.ui.saveButton, () => {
                if (this.ui.saveButton.is("disabled")) {
                    return;
                }

                return this.model
                    .save()
                    .then(() => {
                        // TODO In future we should avoid having passwords on the model, to prevent to have a frontend model with credentials.
                        // Said so, the backend does not return the password in the API response and password is only set in this view, so
                        // it is safe to clear the password after the request is successful, as all the subsequent integrations requests thorught-out
                        // Creator, will not have it in the frontend model.
                        this.model.unset("password", {silent: true});
                        this.options.integrationsCollection.add(this.model);

                        NotificationBar.open(SCENE7_SAVE_MESSAGE, {closeDelay: 7000});
                    });
            });
        },

        _hasAlreadyIntegration() {
            return Boolean(this.options.integrationsCollection.get(this.model));
        },

        _getScene7IntegrationModel() {
            const existingScene7Model = this.options.integrationsCollection.findWhere({type: Scene7IntegrationModel.type});
            if (existingScene7Model) {
                return existingScene7Model;
            }

            return new Scene7IntegrationModel();
        },

        _focusPasswordInput(event) {
            if (!this.model.isNew()) {
                event.target.select();
            }
        },

        _updateModel() {
            const formData = {
                username: this.ui.usernameInput.val(),
                password: this.ui.passwordInput.val(),
                companyName: this.ui.companyNameInput.val(),
                region: Scene7HostedRegionEnum.lookup(this.ui.regionInput.val()).value
            };

            this.model.set(formData);

            const formDataKeys = Object.keys(formData);
            const changed = !isEqual(pick(this._savedModelData, formDataKeys), pick(this.model.attributes, formDataKeys));

            Tooltip.remove(this.ui.saveButtonTooltipWrapper);

            if (!this.model.isValid()) {
                Tooltip.add(this.ui.saveButtonTooltipWrapper, {
                    title: "Invalid Credentials",
                    content: this.model.validationError,
                    placement: "bottom",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: {show: 0, hide: 0}
                });

                this.ui.saveButton.prop("disabled", true);
                return;
            }

            this.ui.saveButton.prop("disabled", !changed);
        },

        _save() {
            this._sequentialSaveButtonAction().then(() => {
                this.ui.saveButton.prop("disabled", true);
                this._savedModelData = this.model.toJSON();
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/Scene7IntegrationView.js